
    import Vue from 'vue';
    import ConsentsMainLogo from "@/components/Logo/ConsentsMainLogo.vue"
    import { settingsHelper } from '@/store/modules/settings';
    import { supportsObjectFit } from '@/util/browser';
    const settingsHelpers = settingsHelper.mapGetters(['logo', 'logoXs', 'client']);
    export default Vue.extend({
        name: 'CompanyLogo',
        components: {
            ConsentsMainLogo,
        },
        props: {
            small: { type: Boolean, default: false }
        },
        data() {
            return { 
                transformDistance: undefined, 
                transformScale: undefined 
            }
        },
        computed: {
            ...settingsHelpers,
            supportsObjectFit() {
                return supportsObjectFit;
            },
            src(): string {
                return (this.small ? this.logoXs : this.logo) || '/image/clients/Consents.png';
            },
            cname(): string {
                return (this.client) + ' logo' || 'consents.online logo';
            },
            transformObject(): object|null {
                return this.transformDistance ? {'transform': `scale(${this.small ? this.transformScale : 1}) translateX(${!this.small ? this.transformDistance : 0}px)`} : null
            },
        },
        methods: {
            refreshTransformDistance() {
                let img = new Image()
                img.onload = ()=>{ this.transformScale = img.height < 66 ? 0.7 : 1 }
                img.src = this.src
                this.transformDistance = this.$parent.$el.firstChild.clientWidth/2 - this.$el.clientWidth/2
            }
        },
        watch: {
            small(val) {
                if(val == true) this.$el.style.transition = "transform 0.2s ease"
            }
        },
        mounted() {
            if (!supportsObjectFit) {
                const i = this.$refs.wrapper as HTMLDivElement;
                i.style.backgroundImage = `url(${this.src})`;
            }
            if(!this.logo) this.refreshTransformDistance()
            window.addEventListener("resize", ()=>{ this.refreshTransformDistance() })
        }
    });
